import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import { SoftphoneProvider } from "./context/SoftphoneContext";
import { installChunkReloadGuard } from "./lib/chunkReload";
import "./index.css";

// Auto-recover stale tabs whose lazy-loaded chunks were pruned by a newer deploy.
installChunkReloadGuard();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <SoftphoneProvider>
          <App />
        </SoftphoneProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
